export default class Reversal {
  /**
   * Create new invoice and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get dateTimeUtc () {
    return this._dateTimeUtc
  }

  /**
   * @param {string} value
   */
  set dateTimeUtc (value) {
    this._dateTimeUtc = new Date(value)
  }
}
